import React, { Component } from "react";
import ReactDOM from "react-dom"; // Added for React Portal
import './Facilities.css';
import axios from "../../utils/axiosInstance";

class Facilities extends Component {
  constructor(props) {
    super(props);

    this.state = {
      facilities: [],
      showModal: false,
      loading: false,
    };
  }

  componentDidMount() {
    const { postId } = this.props;

    if (postId) {
      this.fetchFacilities(postId);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.postId !== this.props.postId) {
      this.fetchFacilities(this.props.postId);
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "auto";
  }

  fetchFacilities = async (postId) => {
    try {
      this.setState({ loading: true });

      const response = await axios.get(`/facility/${postId}`);

      this.setState({
        facilities: response.data.data || [],
        loading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  openModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflow = "hidden";
  };

  closeModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflow = "auto";
  };

  renderFacilityCard = (facility, index) => {
    return (
      <div key={index} className="col-6 col-md-4 col-lg-3">
        <div className="facility-card p-3 rounded-3 text-center border bg-white h-100">
          <div
            className="fs-3 text-primary-green mb-2 d-block"
            dangerouslySetInnerHTML={{
              __html: facility.facility_icon,
            }}
          />
          <span className="fw-medium fs-7 text-dark">
            {facility.facility_name}
          </span>
        </div>
      </div>
    );
  };

  render() {
    const { facilities, showModal, loading } = this.state;
    const previewFacilities = facilities.slice(0, 8);

    return (
      <>
        <section className="mb-5 pb-4 border-bottom">
          <h3 className="fw-bold mb-4 section-heading">
            Premium Facilities
          </h3>

          {loading ? (
            <div className="text-center py-4 text-muted">
              Loading facilities...
            </div>
          ) : (
            <>
              <div className="row g-3">
                {previewFacilities.map(this.renderFacilityCard)}
              </div>

              {facilities.length > 8 && (
                <div className="text-center mt-4">
                  <button
                    className="btn btn-primary px-4 py-2 rounded-pill shadow-sm"
                    onClick={this.openModal}
                  >
                    Show All {facilities.length} Facilities
                  </button>
                </div>
              )}
            </>
          )}
        </section>

        {/* Modal rendered via Portal to bypass parent CSS transforms */}
        {showModal && ReactDOM.createPortal(
          <div
            className="facility-modal-overlay"
            onClick={this.closeModal}
          >
            <div
              className="facility-modal-box"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="facility-modal-header">
                <h4 className="mb-0 fw-bold fs-5">
                  All Facilities ({facilities.length})
                </h4>
                <button
                  type="button"
                  className="facility-close-btn"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                  &times;
                </button>
              </div>

              <div className="facility-modal-content">
                <div className="row g-3">
                  {facilities.map(this.renderFacilityCard)}
                </div>
              </div>
            </div>
          </div>,
          document.body 
        )}
      </>
    );
  }
}

export default Facilities;